export default __webpack_public_path__ + "static/media/phone2.751ae493.jpg";